import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as CloseIcon} from "../assets/x-close.svg";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function PatientListDialog({ open, setOpen, data, message }) {
  const navigate = useNavigate();
  const [patientId, setPatientId] = useState('')
  const [patientInfo, setPatientInfo] = useState('')

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    localStorage.removeItem('session_id');
    localStorage.setItem('patient_id', JSON.stringify(patientId));
    localStorage.setItem('patient_name', JSON.stringify(patientInfo?.name));
    // Store complete patient data for PatientInfo component
    localStorage.setItem('patient_data', JSON.stringify(patientInfo));

    handleClose();
    navigate("/voice");
  };

  const formatPatientLabel = (patient) => {
    if (!patient) return '';

    const name = patient.name || 'Unknown';
    const dob = patient.birth_date ? new Date(patient.birth_date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }) : '';
    const patientId = patient.id || patient.mrn || '';

    let label = name;
    if (dob) label += ` (DOB: ${dob})`;
    if (patientId) label += ` – Patient ID: ${patientId}`;

    return label;
  };

  return (
    <>
      
        <Dialog
  aria-labelledby="customized-dialog-title"
  open={open}
  fullWidth
  maxWidth="lg"
  className="patientList"
  BackdropProps={{
    sx: {
      backgroundColor: 'transparent',
    }
  }}
  PaperProps={{
    sx: {
      background: 'rgba(200, 200, 200, 0.25)',
      backdropFilter: 'blur(12px)',
      borderRadius: '14px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      minHeight: '200px',
      width: '90%',
      maxWidth: '900px',
    }
  }}
      >
        <DialogTitle sx={{
          borderRadius: '14px 14px 0 0',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          background: 'transparent'
        }} id="customized-dialog-title">
          <Typography className="choose-patient-text">
            {/* Choose the correct patient */}
            Choose the correct patient
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
           <Typography variant="xxsSize" className="fw-500 white-color">
            {" "}
            {message}
          </Typography> 
          {/* {data?.map((dt, i) => { */}
          {/* return ( */}
          {/* <> */}
          {data &&
            <FormGroup className="patient-list" sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={patientId === data?.id}
                    value={data?.id}
                    onChange={() => {
                      setPatientId(data?.id);
                      setPatientInfo(data);
                    }}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.5)',
                      '&.Mui-checked': {
                        color: '#00D173',
                      },
                    }}
                  />
                }
                sx={{
                  fontSize: '14px',
                  color: '#fff',
                  fontWeight: '500',
                  '& .MuiFormControlLabel-label': {
                    fontSize: '14px',
                  }
                }}
                label={formatPatientLabel(data)}
              />
            </FormGroup>
          }
          {/* </>
            );
          })} */}
        </DialogContent>
        {patientId && (<>
          <DialogActions sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            background: 'transparent',
          }}>
            <Button onClick={onSubmit} className="submit-button" disabled={!patientId ? true : false}>Submit</Button>
          </DialogActions>
        </>)}

      </Dialog>
    </>
  );
}